<template>
  <div class="yuyuetip">
    <div class="shuoming11">
      <div class="title11">预约方式</div>
      <div class="tipp">1: 关注"<span class="tipzhu">中华保险广东分公司</span>",咨询客服办理预约;</div>
      <div class="tipp">2: 联系专属业务员{{coupon.related ? coupon.related.salesman : ''}},联系电话:<a :href="'tel:' + coupon.related.salesman_mobile">{{coupon.related ? coupon.related.salesman_mobile : ''}}</a>;</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        coupon: {}
      }
    },
    created() {
      if (this.$route.query.coupon) {
        this.coupon = this.$route.query.coupon
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>
  .shuoming11 {
    margin: 20px;
    /*   background-color: #e6e6e6; */
    display: flex;
    flex-direction: column;
    border: 1px solid #c3c3c5;
    /*    align-items: center;
        justify-content: flex-start; */
    padding: 10px;
    font-size: 15px;
    position: absolute;
    top: 25%;
  }

  .title12 {
    margin: 10px 0;
    text-align: center;
    font-size: 20px;
  }

  .tip3 {
    display: flex;
    justify-content: flex-start;
    color: red;
  }

  .tipp {
    /*   display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column; */
    font-size: 16px;
  }

  .tipzhu {
    color: red;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/yuyuetip.vue